// extracted by mini-css-extract-plugin
export var arrows = "_43-6";
export var decrementer = "_43-a";
export var disabled = "_43-4";
export var error = "_43-1";
export var hiddenText = "_43-b";
export var incrementer = "_43-9";
export var input = "_43-8";
export var inputWrapper = "_43-0";
export var leadingIcon = "_43-c";
export var readonly = "_43-3";
export var regular = "_43-7";
export var small = "_43-5";
export var warning = "_43-2";